import AddIcon from "@mui/icons-material/Add";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, Switch } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import { PsNoData } from "../../components";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import ModuleAccess from "../../context/moduleAccess";
import {
  _DELETE_SCHOOL,
  _LIST_SCHOOLS,
  _SCHOOL_STATUS_UPDATE,
} from "../../models/schoolsModel";
import { SAAS_SITE_URL, upperCase } from "../../utils";
import AppLayoutSecondaryHeader from "../layout/AppLayout/AppLayoutSecondaryHeader";
import AddSchoolForm from "./addSchoolForm";
import EditSchoolForm from "./editSchoolForm";
import NewEditSchoolForm from "./newEditForm";
import PsOffCanvasWindow from "../../components/PsOffCanvasWindow";

const SchoolMgt = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showLogins, setShowLogins] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [viewData, setViewData] = useState([]);

  const { openDialog } = useDialog();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _LIST_SCHOOLS().then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
        setDataView(res.data);
      } else {
        setDataList([]);
        setDataView([]);
      }
      setLoader(false);
    });
  };

  const handleStatusChange = (item, sta) => {
    openDialog({
      title: "Confirm",
      message: (
        <>
          Would you like to set your
          <br />
          <b>{item.school_name}</b> status to{" "}
          {sta == "1" ? <b>In-Active</b> : <b>Active</b>}?
        </>
      ),
      onConfirm: () => confirmUpdate(item, sta),
    });
  };

  const confirmUpdate = (item, sta) => {
    setLoader(true);
    _SCHOOL_STATUS_UPDATE({
      id: item.id,
      uuid: item.uuid,
      active_status: sta == "1" ? "0" : "1",
    }).then((res) => {
      if (res.status == "1") {
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
        setLoader(false);
      }
    });
  };

  const handleDeleteClick = (item) => {
    openDialog({
      title: "Confirm",
      message: (
        <>
          Do you want to Delete the School
          <br />
          <b>{item.school_name}</b> ?
        </>
      ),
      onConfirm: () => confirmDelete(item),
    });
  };

  const confirmDelete = (item) => {
    setLoader(true);
    _DELETE_SCHOOL({ id: item.id, uuid: item.uuid }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Deleted");
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Delete",
        });
        setLoader(false);
      }
    });
  };

  const handleEdit = (item) => {
    console.log(item);
    setViewData(item);
    setEditModal(true);
  };

  const handleSearch = (e) => {
    let v = upperCase(e.target.value);
    let m = dataList.filter(
      (item) =>
        upperCase(item.school_name).indexOf(v) > -1 ||
        upperCase(item.school_mobile).indexOf(v) > -1,
    );
    setDataView(m);
  };

  const handleviewLoginsClick = (item) => {
    setViewData(item);
    setShowLogins(true);
  };

  return (
    <>
      <AppLayoutSecondaryHeader title="Schools">
        <ModuleAccess module="school_mgt" action="action_create">
          <IconButton
            color="inherit"
            onClick={(e) => setAddModal(true)}
            title="Add Module"
          >
            <AddIcon />
          </IconButton>
        </ModuleAccess>
        <IconButton color="inherit" onClick={(e) => loadData()} title="Refresh">
          <AutorenewIcon />
        </IconButton>
      </AppLayoutSecondaryHeader>
      <div className="container mt-115">
        <Row className="mb-2">
          <Col md={12}>
            <InputGroup size="sm">
              <InputGroup.Text>
                <SearchIcon />
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="fw-bold"
                placeholder="Search by School Name, Mobile"
                onChange={handleSearch}
              />
            </InputGroup>
          </Col>
        </Row>

        <Spin spinning={loader}>
          <div>
            <Table size="sm" hover bordered>
              <thead>
                <tr className="fs-12">
                  <th width="45" className="text-center">
                    S.No
                  </th>
                  <th width="">Name of the School</th>
                  <th width="100">Mobile</th>
                  <th width="">Email Id</th>
                  <th width="">Company Name</th>
                  <th width="70" className="text-center">
                    Status
                  </th>
                  <th width="120" className="text-center">
                    #
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataView.map((item, i) => {
                  return (
                    <tr key={i} className={`fs-12 valign-middle`}>
                      <td
                        align="center"
                        className={item.active_status == "0" && "bg-red-50"}
                      >
                        {i + 1}
                      </td>
                      <td className={item.active_status == "0" && "bg-red-50"}>
                        <div className="fw-bold text-uppercase">
                          <a
                            href={SAAS_SITE_URL + item.school_prefix}
                            target="_blank"
                          >
                            {item.school_name}
                          </a>
                        </div>
                        <span>
                          {item.school_place}
                          {item.school_city &&
                            item.school_city.length > 0 &&
                            ","}
                          {item.school_city}
                        </span>
                      </td>
                      <td className={item.active_status == "0" && "bg-red-50"}>
                        {item.school_mobile}
                      </td>
                      <td className={item.active_status == "0" && "bg-red-50"}>
                        {item.school_email}
                      </td>
                      <td
                        className={
                          item.active_status == "0"
                            ? "bg-red-50 fw-bold"
                            : "fw-bold"
                        }
                      >
                        {item.company_name}
                        <br />
                        <span className="fs-11 text-primary">
                          {item.emp_name}
                        </span>
                      </td>
                      <td
                        align="center"
                        className={item.active_status == "0" && "bg-red-50"}
                      >
                        <Switch
                          size="small"
                          checked={item.active_status == "1" ? true : false}
                          onChange={(e) =>
                            handleStatusChange(item, item.active_status)
                          }
                        />
                      </td>
                      <td
                        align="center"
                        className={item.active_status == "0" && "bg-red-50"}
                      >
                        <ModuleAccess
                          module="school_mgt"
                          action="action_update"
                        >
                          <IconButton
                            title="Edit"
                            onClick={(e) => handleEdit(item)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                        <ModuleAccess
                          module="school_mgt"
                          action="action_delete"
                        >
                          <IconButton
                            title="Delete"
                            onClick={(e) => handleDeleteClick(item)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                      </td>
                    </tr>
                  );
                })}
                {dataList.length < 1 && !loader && (
                  <tr>
                    <td colSpan={7}>
                      <PsNoData withHeight />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Spin>
      </div>

      <AddSchoolForm
        show={addModal}
        onHide={(e) => setAddModal(false)}
        onSuccess={() => {
          setAddModal(false);
          loadData();
        }}
      />

      <PsOffCanvasWindow
        title={
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* Left-aligned school info with centered content */}
            <div
              style={{
                flex: 1,
                textAlign: "center",
                minWidth: 0, // Allows text truncation if needed
              }}
            >
              <div
                style={{
                  textTransform: "uppercase",
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: "1.2",
                }}
              >
                {viewData.school_name}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "normal",
                  lineHeight: "1.3",
                }}
              >
                {viewData.school_place}, {viewData.school_city}
              </div>
            </div>

            {/* Right-aligned plan end date */}
            <div
              style={{
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "right",
                whiteSpace: "nowrap",
                marginLeft: "20px", // Add some spacing
              }}
            >
              Plan ends on: {viewData.plan_expires_on}
            </div>
          </span>
        }
        onHide={(e) => {
          setEditModal(false);
          setViewData([]);
        }}
        show={editModal}
        size="lg"
      >
        {editModal && <NewEditSchoolForm dataSource={viewData} />}
      </PsOffCanvasWindow>
    </>
  );
};
export default SchoolMgt;
